import "../styles/Button.css";

const Button = ({ content, color = "#ff0000", onClick }) => {

    return (
        <button className="button" onClick={onClick} style={{background: color}}>{content}</button>
    )
}

export default Button;
